import { Button, Layout, Spin } from 'antd'
import { t } from 'i18next'
import React, { useContext, useEffect, useState } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import { useForm } from 'antd/es/form/Form'
import { get, post } from '../../Common/api'
import { Color } from '../../Common/Color'
import TeleconsultingCompanyForm from './TeleconsultingCompanyForm'
import TeleconsultingCompaniesList from './TeleconsultingCompaniesList'
import CustModal from '../../Common/CustModal'
import GlobalContext from '../GlobalContext'
import { ActionButton } from '../../Common/Common'

export default function TeleconsultingCompaniesPage () {
  const [teleconsultingCompanies, setTeleconsultingCompanies] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [form] = useForm()
  const { notificationApi } = useContext(GlobalContext)

  useEffect(() => {
    getTeleconsultingCompanies()
  }, [])

  const getTeleconsultingCompanies = async () => {
    setLoading(true)
    await get({
      url: 'admin/teleconsulting_companies',
      params: {},
      onSuccess: (res) => {
        setLoading(false)
        setTeleconsultingCompanies(res)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const postTeleconsultingCompany = async (params) => {
    setLoading(true)
    await post({
      url: 'admin/teleconsulting_companies',
      params,
      notification: { api: notificationApi, state: 'create' },
      onSuccess: () => {
        setModalVisible(false)
        setLoading(false)
        getTeleconsultingCompanies()
      },
      onFailure: (errors) => {
        setLoading(false)
        form.setFields(
          Object.keys(errors).map((key) => ({
            name: key,
            errors: errors[key]
          }))
        )
      }
    })
  }

  const openAddModal = () => {
    form.resetFields()
    setModalVisible(true)
  }

  const onAdd = async (values) => {
    await postTeleconsultingCompany(values)
  }

  return (
    <Layout>
      <Layout style={{ padding: '1em 0', color: Color.dark_blue, fontSize: '24px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ marginRight: '20px' }}><b>{teleconsultingCompanies.length}</b> {t('Admin.TeleconsultingCompaniesPage.title')}</div>
          <ActionButton onClick={openAddModal} type="primary" style={{ marginLeft: 'auto' }} shape="circle" icon={<PlusOutlined />} />
        </div>
      </Layout>
      <Spin spinning={loading}>
        <TeleconsultingCompaniesList teleconsultingCompanies={teleconsultingCompanies}/>
        <CustModal
          open={modalVisible}
          setOpen={setModalVisible}
          width="1000px"
          title={t('Admin.TeleconsultingCompaniesPage.addTitle')}
          onOk={form.submit}
          confirmLoading={loading}
        >
          <Spin spinning={loading}>
            <TeleconsultingCompanyForm form={form} onFinish={onAdd}/>
          </Spin>
        </CustModal>
      </Spin>
    </Layout>
  )
}
